import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

interface Props {
  columnTitle?: string;
  infoTip: ReactNode;
  leftElement?: ReactNode;
}

export const ColumnHeaderInfoTip = ({ columnTitle, infoTip, leftElement }: Props) => (
  <div css={styles.columnHeader}>
    {leftElement}
    {columnTitle && (
      <Text as='span' size='medium' className='title'>
        {columnTitle}
      </Text>
    )}
    {infoTip}
  </div>
);

const styles = {
  columnHeader: css`
    align-items: center;
    display: flex;
    gap: ${theme.spacing(0.5)};

    .title {
      color: ${theme.colors.neutral40};
    }
  `,
};
